import Layout from '@/layout';

const menuRouter = [
	{
	    path: "/magazine",
	    component: () => import("@/views/magazine/index.vue"),
	    meta: { auth: 65536 },
	    name: "杂志-上海教育科研",
	},
	{
		path: "/chiefedit",
		component: () => import("@/views/magazine/chiefedit.vue"),
		meta: { auth: 65536 },
		name: "杂志主编",
	},
	{
		path: "/information",
		component: () => import("@/views/magazine/information.vue"),
		meta: { auth: 65536 },
		name: "杂志-上海教育情报",
	}
];

export default [
    {
        path: "/magazine",
        component: Layout,
        children: [...menuRouter]
    }
];